import React from 'react'
import { PWA_DEHVAND_APP_URL } from '../../../globalDef'

const logoH = require("./../../../assets/images/logo/logoNameHoriz.png")

const Navbar = () => (
    <header className="hd">
        <div className="wrap">
            <img src={logoH} alt="ده‌وند" />
            <nav className="nav">
                <a className="hide-sm" href="#features">امکانات</a>
                <a className="hide-sm" href="#shop">بازار</a>
                <a className="hide-sm" href="#ads">تبلیغات</a>
                <a className="hide-sm" href="#contact">ارتباط با ما</a>
                <a className="btn sm" href={PWA_DEHVAND_APP_URL} target="_blank" rel="noopener noreferrer">ورود به وب‌اپ</a>
            </nav>
        </div>
    </header>
)

export default Navbar
